import { RootState } from '../store';

export const selectDepartmentOptions = (state: RootState) => state.department.departmentOptions;

export const selectDepartmentOptionsRequestStatus = (state: RootState) =>
  state.department.departmentOptionsRequestStatus;
